<template>
    <AccountLayout :loading="0" :isError=false>
        <v-container id="login">
            <v-overlay :value="loading">
                <v-sheet justify-center align-center outlined color="transparent">
                    <v-progress-circular indeterminate :size="50">
                    </v-progress-circular> </v-sheet
            ></v-overlay>
            <v-row class="error-margin">
                <v-col md="6" sm="12" cols="12" class="d-flex align-center">
                    <v-img
                        :src="require('@/assets/Outer space-pana.svg')"
                        contain
                    />
                </v-col>
                <v-col
                    md="6"
                    sm="12"
                    cols="12"
                    class="d-flex align-center"
                    id="div-top"
                >
                    <v-row>
                        <v-col>
                            <div class="prompt-200">404</div>
                            <div class="prompt-28" id="page-not-found">
                                Page Not Found
                            </div>
                            <div
                                class="mb-5 mt-5 sarabun-18"
                                style="color: #9d9b9a"
                                id="page-not-found-content"
                            >
                                <li>
                                    {{ $t("message.notFoundPage.message1") }}
                                </li>
                                <li>
                                    {{ $t("message.notFoundPage.message2") }} {{ organization?.[`name_${locale}`] }} {{durationDate !== "" ? $t("message.notFoundPage.message3") + durationDate : ""}}
                                </li>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </AccountLayout>
</template>
  
<script>
import AccountLayout from "@/components/common/AccountLayout";
import * as services from "@/services";
import i18n from '@/i18n';
import { formatDateTimeLocale } from '@/utils/date';

export default {
    name: "ErrorComp",
    components: { AccountLayout },
    data: () => ({
        registrationFormDetail: null,
        organization: null,
        loading: 0,
        isError:false
    }),
    computed:{
        locale(){
            return i18n.locale
        },
        durationDate(){
            if(this.registrationFormDetail != null){
                let startDate = this.registrationFormDetail?.opening_date
                let endDate = this.registrationFormDetail?.enrollment_date
                return formatDateTimeLocale(startDate, this.locale || "th") + " - " + formatDateTimeLocale(endDate, this.locale|| "th")
            }
            else{
                return ""
            }
        }
    },
    methods: {
        async getResource() {
            try {
                this.loading++;
                let res = await services.getOrganization();
                this.organization = res.data.data.organization;
                let link = localStorage.getItem("registerLink")
                if(link != null || link != undefined){
                    let { data } = await services.getRegisterFormIDFromLink({
                        link: link,
                    });
                    if(data.status.code !== 404){
                        this.registrationFormDetail = data.data.register_form_config;
                    }
                }

            } catch (err) {
                console.log(err);
            } finally {
                this.loading--;
            }
        },
    },
    mounted() {
        i18n.locale = localStorage.getItem("language")
        this.getResource();
    },
};
</script>